import './light-rays.js';
import './router.js';
import './flip.js';
import './case-study.js';
import './portfolio.js';
import { initChat } from './chat.js';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initChat, { once: true });
} else {
  initChat();
}
